import type { RenderNode } from "../../../util/src/layout-compiler/types.js";
import { isProtectedMediaSrc } from "../display-editor/ProtectedMediaCacheContext";

/**
 * Collects protected image/video URLs from a compiled render tree (recursive).
 */
export function collectMediaSources(nodes: RenderNode[]): string[] {
  const sources = new Set<string>();

  function visit(node: RenderNode) {
    if (node.kind === "image" || node.kind === "video") {
      const src = node.src;
      if (src && isProtectedMediaSrc(src)) {
        sources.add(src);
      }

      if (
        node.kind === "video" &&
        node.poster &&
        isProtectedMediaSrc(node.poster)
      ) {
        sources.add(node.poster);
      }
    }

    if ("children" in node) {
      for (const child of node.children) {
        visit(child);
      }
    }
  }

  for (const node of nodes) {
    visit(node);
  }

  return Array.from(sources);
}
